export var BusinessTaxIdFormatterFactory = (function() {
    /* Public Functions */

    var getTaxIdFormatter = function(countryCode) {
        switch (countryCode) {
        case 'AR': {
            return commonFormatterWithoutCountryCode('*********');
        }
        case 'ZA': {
            return zaFormatter();
        }
        case 'ID': {
            return commonFormatterWithoutCountryCode('**.***.***.*-***.');
        }
        case 'IT': {
            return commonFormatterWithCountryCode(countryCode, '********');
        }
        case 'MX': {
            return commonFormatterWithoutCountryCode();
        }
        case 'VN': {
            return commonFormatterWithoutCountryCode('*******');
        }
        case 'ES': {
            return commonFormatterWithCountryCode(countryCode, '******');
        }
        case 'NL': {
            return commonFormatterWithCountryCode(countryCode, '*********');
        }
        case 'PF': {
            return commonFormatterWithoutCountryCode('***');
        }
        case 'CO': {
            return commonFormatterWithoutCountryCode('******');
        }
        case 'FR': {
            return commonFormatterWithoutCountryCode('***********');
        }
        case 'AU': {
            return commonFormatterWithoutCountryCode('**-***-***-');
        }
        case 'NZ': {
            return commonFormatterWithoutCountryCode('***-***-');
        }
        case 'GB': {
            return commonFormatterWithCountryCode(countryCode, '******');
        }
        case 'DE': {
            return commonFormatterWithCountryCode(countryCode, '******');
        }
        case 'NO': {
            return commonFormatterWithCountryCode(countryCode, '******');
        }
        case 'SE': {
            return commonFormatterWithCountryCode(countryCode, '*********');
        }
        case 'AT': {
            return commonFormatterWithCountryCode('ATU', '*****');
        }
        case 'FI': {
            return commonFormatterWithCountryCode(countryCode, '*****');
        }
        case 'DK': {
            return commonFormatterWithCountryCode(countryCode, '*****');
        }
        case 'IE': {
            return commonFormatterWithCountryCode(countryCode, '*****');
        }
        case 'IS': {
            return commonFormatterWithCountryCode(countryCode, '***');
        }
        case 'PT': {
            return commonFormatterWithCountryCode(countryCode, '******');
        }
        // Those with No business TaxId.
        default: {
            return defaultFormatter();
        }
        }
    };

    var commonFormatterWithCountryCode = function(countryCode, taxIdMask) {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? countryCode + taxId.value.toUpperCase() : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            if (taxIdMask) {
                return taxIdValue ? countryCode + taxIdMask + taxIdValue.substr(-3) : '';
            } else {
                return taxIdValue ? countryCode + '*'.repeat(taxIdValue.length - 3) + taxIdValue.substr(-3) : '';
            }
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId
        };
    };

    var commonFormatterWithoutCountryCode = function(taxIdMask) {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.toUpperCase() : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            if (taxIdMask) {
                return taxIdValue ? taxIdMask + taxIdValue.substr(-3) : '';
            } else {
                return taxIdValue ? '*'.repeat(taxIdValue.length - 3) + taxIdValue.substr(-3) : '';
            }
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId
        };
    };

    var zaFormatter = function() {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            if (/\-/.test(taxIdValue)) {
                return taxIdValue ? '****-***-' + taxIdValue.substr(-4) : '';
            } else {
                return taxIdValue ? '****-***-' + taxIdValue.substr(-3, 2) + '-' + taxIdValue.substr(-1) : '';
            }
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId
        };
    };

    // CountryCodes with no Business TaxId
    var defaultFormatter = function() {
        var formatToService = function(taxId) {
            return null;
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            return null;
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId
        };
    };

    return {
        getTaxIdFormatter: getTaxIdFormatter
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/tax-id/business-tax-id-formatter.js
// module id = 343
// module chunks = 0